import React from "react";
import { Link } from "react-router-dom";
import { CButton } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilArrowLeft } from "@coreui/icons";
import LanguageSwitcher from "../../../components/LanguageSwitcher/LanguageSwitcher";

const CameraHeader = ({ deviceName, organizationName, t }) => {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 page-header-mobile gap-3">

      <div className="d-flex flex-column">
        <h2
          className="mb-0 fw-bold text-dark d-flex align-items-center"
          style={{ fontSize: '1.5rem', minHeight: '38px' }}
        >
          {deviceName}
        </h2>
        {organizationName && (
          <span className="text-muted fw-bold" style={{ fontSize: '0.9rem' }}>
            {organizationName}
          </span>
        )}
      </div>

      <div className="d-flex align-items-stretch gap-3">

        <LanguageSwitcher size="" className="m-0" />

        <Link to="/dashboard" className="text-decoration-none d-block">
          <CButton
            color="secondary"
            className="btn-mobile-100 w-100 h-100 d-flex align-items-center fw-bold"
          >
            <CIcon icon={cilArrowLeft} className="me-2" /> {t("common.back")}
          </CButton>
        </Link>

      </div>
    </div>
  );
};

export default CameraHeader;